import { i18n } from "../../translate/i18n";

// Nome da cópia no idioma de quem duplica (o backend só usa o sufixo
// "(cópia)" como reserva quando o nome não vem).
export const nomeDaCopia = (nome) =>
  i18n.t("aeros.campaign.duplicate.copyName", { name: nome });

// Cria a cópia no backend (INATIVA, sem agendamento) e devolve a campanha
// nova para a tela abrir o modal de edição dela.
const duplicaCampanha = async (api, campanha) => {
  const { data } = await api.post(`/campaigns/${campanha.id}/duplicate`, {
    name: nomeDaCopia(campanha.name),
  });
  return data;
};

export default duplicaCampanha;
